import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Document, DocumentListResult, DocumentType } from '../api/data-model';
import { BACKEND_URL } from '../app.config';
import { LinkDto } from '../api/common/link-dto';

@Injectable()
export class DocumentService {
  constructor(
    private readonly http: HttpClient,
    @Inject(BACKEND_URL) private readonly baseUrl: string
  ) { }

  getDocuments(
    entityType: number,
    entityId: string,
    targetFolder?: string,
    nextLink?: string, 
    orderBy?: string,  
    maxResultCount: number = 10 
  ): Observable<DocumentListResult> {
    return this.http.get<DocumentListResult>(
      this.baseUrl + '/api/app/document',
      {
        params: {
          EntityType: entityType,
          EntityId: entityId,
          MaxResultCount: maxResultCount,
          TargetFolder: targetFolder || '',
          NextLink: nextLink ?? '',
          orderBy: orderBy || '',
        },
      }
    );
  }

  getWorkspace(entityType: number, entityId: string): Observable<LinkDto> {
    return this.http.get<LinkDto>(this.baseUrl + '/api/app/document/workspace', {
      params: {
        EntityType: entityType,
        EntityId: entityId,
      }
    });
  }

  uploadDocuments(formData: FormData): Observable<Document[]> {
    return this.http.post<Document[]>(this.baseUrl + '/api/app/document/upload-documents', formData);
  }

  getDocumentTypes(): Observable<DocumentType[]> {
    return this.http.get<DocumentType[]>(this.baseUrl + '/api/app/document/document-types');
  }
}
